export default store => store.okapi;
